/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetOrderStatisticsAdminResponse } from '../models/GetOrderStatisticsAdminResponse';
import type { GetServiceStatisticType } from '../models/GetServiceStatisticType';
import type { OrderStatisticAdminDto } from '../models/OrderStatisticAdminDto';
import type { OrderStatisticOperatorDto } from '../models/OrderStatisticOperatorDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrderStatisticsService {
    /**
     * @returns OrderStatisticOperatorDto OK
     * @throws ApiError
     */
    public static getOrderStatisticSummeryOperator({
        branchId,
    }: {
        branchId: number,
    }): CancelablePromise<OrderStatisticOperatorDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/orderstatistics/summery/{branchId}',
            path: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderStatistics`
     * @returns GetOrderStatisticsAdminResponse OK
     * @throws ApiError
     */
    public static getServiceStatisticsAdmin({
        startDate,
        endDate,
        type,
        serviceId,
        regionId,
        branchId,
    }: {
        startDate: string,
        endDate: string,
        type: GetServiceStatisticType,
        serviceId?: number,
        regionId?: number,
        branchId?: number,
    }): CancelablePromise<GetOrderStatisticsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orderstatistics',
            query: {
                'serviceId': serviceId,
                'regionId': regionId,
                'branchId': branchId,
                'startDate': startDate,
                'endDate': endDate,
                'type': type,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderStatistics`
     * @returns OrderStatisticAdminDto OK
     * @throws ApiError
     */
    public static getServiceStatisticSummeryAdmin({
        branchId,
        serviceId,
        regionId,
        startDate,
        endDate,
    }: {
        branchId?: number,
        serviceId?: number,
        regionId?: number,
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<OrderStatisticAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orderstatistics/summery',
            query: {
                'branchId': branchId,
                'serviceId': serviceId,
                'regionId': regionId,
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderStatistics`
     * @returns any OK
     * @throws ApiError
     */
    public static migrateToStatisticsAdmin({
        limit,
    }: {
        limit?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orderstatistics/migrate-to-statistics',
            query: {
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
